export const QUESTION_BANK = [
  {
    id: 'q-geography-1',
    difficulty: 'adult',
    audience: 'adult',
    category: 'Geografi',
    languages: {
      sv: {
        text: 'Vilken är Sveriges högsta fjälltopp?',
        options: ['Kebnekaise', 'Helags', 'Sarektjåkkå', 'Åreskutan'],
        explanation: 'Kebnekaise är Sveriges högsta berg med sydtoppen 2 095,6 meter över havet.'
      },
      en: {
        text: 'What is Sweden\'s highest mountain peak?',
        options: ['Kebnekaise', 'Helags', 'Sarektjåkkå', 'Åreskutan'],
        explanation: 'Kebnekaise is Sweden\'s highest mountain with the southern peak at 2,095.6 meters above sea level.'
      }
    },
    correctOption: 0
  },
  {
    id: 'q-geography-2',
    difficulty: 'family',
    audience: 'family',
    category: 'Geografi',
    languages: {
      sv: {
        text: 'Vilken svensk stad kallas för Lilla London?',
        options: ['Göteborg', 'Malmö', 'Stockholm', 'Uppsala'],
        explanation: 'Smeknamnet kom under 1800-talet då många britter flyttade till Göteborg.'
      },
      en: {
        text: 'Which Swedish city is called Little London?',
        options: ['Gothenburg', 'Malmö', 'Stockholm', 'Uppsala'],
        explanation: 'The nickname came in the 19th century when many Britons moved to Gothenburg.'
      }
    },
    correctOption: 0
  },
  {
    id: 'q-animals-1',
    difficulty: 'kid',
    audience: 'kid',
    category: 'Djur',
    languages: {
      sv: {
        text: 'Vilket djur säger "kuckeliku"?',
        options: ['Hund', 'Katt', 'Tupp', 'Ko'],
        explanation: 'Tuppen är den som gal kuckeliku på morgonen.'
      },
      en: {
        text: 'Which animal says "cock-a-doodle-doo"?',
        options: ['Dog', 'Cat', 'Rooster', 'Cow'],
        explanation: 'The rooster is the one that crows cock-a-doodle-doo in the morning.'
      }
    },
    correctOption: 2
  },
  {
    id: 'q-history-1',
    difficulty: 'adult',
    audience: 'adult',
    category: 'Historia',
    languages: {
      sv: {
        text: 'När blev Sverige medlem i EU?',
        options: ['1993', '1995', '1998', '2001'],
        explanation: 'Sverige gick med i EU den 1 januari 1995.'
      },
      en: {
        text: 'When did Sweden become a member of the EU?',
        options: ['1993', '1995', '1998', '2001'],
        explanation: 'Sweden joined the EU on January 1, 1995.'
      }
    },
    correctOption: 1
  },
  {
    id: 'q-science-1',
    difficulty: 'family',
    audience: 'family',
    category: 'Naturvetenskap',
    languages: {
      sv: {
        text: 'Hur många planeter finns det i vårt solsystem?',
        options: ['7', '8', '9', '10'],
        explanation: 'Sedan Pluto omklassificerades finns åtta planeter kvar.'
      },
      en: {
        text: 'How many planets are there in our solar system?',
        options: ['7', '8', '9', '10'],
        explanation: 'Since Pluto was reclassified, eight planets remain.'
      }
    },
    correctOption: 1
  },
  {
    id: 'q-sport-1',
    difficulty: 'adult',
    audience: 'adult',
    category: 'Sport',
    languages: {
      sv: {
        text: 'Vilken svensk vann Wimbledon 1990?',
        options: ['Björn Borg', 'Stefan Edberg', 'Mats Wilander', 'Robin Söderling'],
        explanation: 'Stefan Edberg vann Wimbledon både 1988 och 1990.'
      },
      en: {
        text: 'Which Swede won Wimbledon in 1990?',
        options: ['Björn Borg', 'Stefan Edberg', 'Mats Wilander', 'Robin Söderling'],
        explanation: 'Stefan Edberg won Wimbledon in both 1988 and 1990.'
      }
    },
    correctOption: 1
  },
  {
    id: 'q-riddle-1',
    difficulty: 'kid',
    audience: 'kid',
    category: 'Gåtor',
    languages: {
      sv: {
        text: 'Jag har ett huvud och en fot men ingen kropp, vad är jag?',
        options: ['En svamp', 'Ett bord', 'En säng', 'En stol'],
        explanation: 'En säng har både huvuds- och fotände.'
      },
      en: {
        text: 'I have a head and a foot but no body, what am I?',
        options: ['A mushroom', 'A table', 'A bed', 'A chair'],
        explanation: 'A bed has both a headboard and a footboard.'
      }
    },
    correctOption: 2
  },
  {
    id: 'q-nature-1',
    difficulty: 'family',
    audience: 'family',
    category: 'Natur',
    languages: {
      sv: {
        text: 'Vid vilken temperatur fryser vatten?',
        options: ['0 °C', '10 °C', '32 °C', '100 °C'],
        explanation: 'Vatten fryser vid 0 °C under normala förhållanden.'
      },
      en: {
        text: 'At what temperature does water freeze?',
        options: ['0 °C', '10 °C', '32 °C', '100 °C'],
        explanation: 'Water freezes at 0 °C under normal conditions.'
      }
    },
    correctOption: 0
  }
];
